import { render, staticRenderFns } from "./PGMPotentialApplicants.vue?vue&type=template&id=ddcd670e&"
import script from "./PGMPotentialApplicants.vue?vue&type=script&lang=js&"
export * from "./PGMPotentialApplicants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports